"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { Button } from "@/shared/ui/buttons/button";

const BTN = "border-highlight-border text-highlight hover:text-highlight";

/** Баннер над списком для тех, у кого ещё нет основной команды (макет). */
export function BoardTeamCta() {
  const t = useTranslations("LfgBoard");
  return (
    <section className="flex flex-col gap-3 rounded-2xl border border-highlight-border bg-highlight-soft/50 p-5 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h2 className="font-heading text-lg font-semibold">{t("ctaTitle")}</h2>
        <p className="text-sm text-muted-foreground">{t("ctaText")}</p>
      </div>
      <Button asChild variant="outline" className={BTN}>
        <Link href="/roster/create">{t("ctaButton")}</Link>
      </Button>
    </section>
  );
}
